import React from 'react';

import styled from 'styled-components';

import { Input, InputAdornment } from 'src/app/components/lib/input';

import type { InputProps } from 'src/app/components/lib/input';

type CurrencyInputProps = InputProps & {
  decimalPlaces?: number;
  disableDecimalPlaceLimit?: boolean;
  excludeCurrencySymbol?: boolean;
  onChange?: (value: string) => void;
};

function formatInputDecimalValue(value: string, maxDecimalPlaces: number) {
  const decimalIndex = value.indexOf('.');
  const beforeDecimalSubstring = value.substring(0, Number(decimalIndex));
  const afterDecimalSubstring = value.substring(Number(decimalIndex) + 1);
  const reachedMaxDecimalPlaces = afterDecimalSubstring.length >= maxDecimalPlaces;

  if (reachedMaxDecimalPlaces) {
    const limitedDecimalValue = afterDecimalSubstring.substring(0, Number(maxDecimalPlaces));
    const formattedValue = `${beforeDecimalSubstring}.${limitedDecimalValue}`;
    return formattedValue;
  }
  return value;
}

export function CurrencyInput(props: CurrencyInputProps) {
  const {
    onChange = () => undefined,
    decimalPlaces = 2,
    disableDecimalPlaceLimit = false,
    excludeCurrencySymbol = false,
    ...other
  } = props;

  function handleOnChange(e) {
    let { value } = e.target;
    const valueHasDecimalPoint = value.includes('.');

    if (valueHasDecimalPoint && !disableDecimalPlaceLimit) {
      value = formatInputDecimalValue(value, decimalPlaces);
    }

    onChange(value);
  }

  return (
    <Input
      {...other}
      autoComplete='off'
      startAdornment={excludeCurrencySymbol ? null : <InputAdornment position='start'>$</InputAdornment>}
      type='number'
      onChange={handleOnChange}
    />
  );
}

export const CurrencyTableInput = styled(CurrencyInput)`
  background-color: white;
  height: var(--sizes-70);

  .MuiInputBase-input {
    padding: var(--sizes-20) var(--sizes-40);
    font: var(--font-extra-small-12pt-normal);
  }

  .MuiInputBase-adornedEnd {
    .MuiInputBase-input {
      padding-left: 0;
    }
  }
`;
